import React, { useState } from 'react';
import { Modal, Button, Upload, Card, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const ImportCSVModal = ({ onSubmit }) => {
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const handleUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const lines = e.target.result.split('\n');
      const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
  
      const getFieldIndices = (fieldNames) => {
        return fieldNames.map(fieldName => headers.indexOf(fieldName));
      };
  
      const nameIndices = getFieldIndices(['name', 'first name', 'last name']);
      const emailIndex = headers.indexOf('email');
      const titleIndex = headers.indexOf('title');
      const companyNameIndices = getFieldIndices(['company', 'company name']);
      const companyUrlIndices = getFieldIndices(['company url', 'url', 'company website', 'company website url']);
  
      const urls = [];
      const invalidEntries = [];
  
      const parseCSVLine = (line) => {
        const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
        return line.split(regex).map(field => field.replace(/(^"|"$)/g, '').trim());
      };
  
      for (let i = 1; i < lines.length; i++) {
        const fields = parseCSVLine(lines[i]);
        const firstName = nameIndices[1] !== -1 ? fields[nameIndices[1]] : '';
        const lastName = nameIndices[2] !== -1 ? fields[nameIndices[2]] : '';
        const name = nameIndices[0] !== -1 ? fields[nameIndices[0]] : `${firstName} ${lastName}`.trim();
        const email = emailIndex !== -1 ? fields[emailIndex] : '';
        const title = titleIndex !== -1 ? fields[titleIndex] : '';
        const companyName = companyNameIndices.some(index => index !== -1 && fields[index]) ? fields[companyNameIndices.find(index => index !== -1)] : '';
        const companyUrl = companyUrlIndices.some(index => index !== -1 && fields[index]) ? fields[companyUrlIndices.find(index => index !== -1)] : '';
  
        if (name && email && (companyName || companyUrl)) {
          urls.push({ name, email, title, companyName, companyUrl });
        } else {
          invalidEntries.push(fields);
        }
      }
  
      if (invalidEntries.length > 0) {
        notification.error({
          message: 'Invalid Entries Detected',
          description: (
            <div>
              <p>The following entries are invalid and will not be uploaded:</p>
              <ul>
                {invalidEntries.map((entry, index) => (
                  <li key={index}>{entry.join(', ')}</li>
                ))}
              </ul>
            </div>
          ),
        });
      }
  
      onSubmit(urls);
      setVisible(false);
      setFileList([]);
    };
    reader.readAsText(file);
    return false;
  };
  

  const handleChange = ({ fileList }) => setFileList(fileList);

  return (
    <>
      <Button icon={<UploadOutlined />} onClick={() => setVisible(true)}>Import CSV Data</Button>
      <Modal
        title="Import CSV"
        visible={visible}
        onCancel={() => {
          setVisible(false);
          setFileList([]);
        }}
        footer={null}
        width={600}
      >
        <Card bordered={false}>
          <p style={{ marginTop: 0 }}>Please upload a CSV file with the following columns: First Name, Last Name, or (Name), Email, Title (optional), Company Name or Company URL. Ensure each record is on a new line.</p>
          <Upload
            beforeUpload={handleUpload}
            accept=".csv"
            fileList={fileList}
            onChange={handleChange}
            style={{ width: '100%' }}
          >
            <Button icon={<UploadOutlined />} style={{ width: '100%', marginTop: '10px' }}>
              Click to Upload CSV
            </Button>
          </Upload>
        </Card>
      </Modal>
    </>
  );
};

export default ImportCSVModal;
